import { ol_Feature, ol_style } from "@omnia/exports/openlayers"
import { darken } from "../../color/color"
import { getFeaturePointStyle, olblue, red } from "../../map/styles/defaults"
import { Datalayer } from "../datalayer"
import { LinePattern } from "../types"
import { DrawingFeature } from "./feature"

export function getDrawingFeatureEditStyle(zone: DrawingFeature) {

    const { feature, layer } = zone
    if (!feature) return

    let style;

    if (zone.isBuffer()) {

        style = new ol_style.Style({})

    }

    else if (zone.isText()) {

        style = (f, resolution) => [
            new ol_style.Style({
                stroke: new ol_style.Stroke({
                    color: "#fff",
                    width: 4,
                    lineDash: [7, 7]
                })
            }),
            new ol_style.Style({
                stroke: new ol_style.Stroke({
                    color: "#000",
                    width: 2,
                    lineDash: [7, 7]
                })
            }),
            ...zone.getTextStyles(resolution, 0)
        ]

    }

    else if (zone.isLine()) {

        style = (f, resolution) => [
            ...getDrawingLineStyle(feature, zone, true),
            ...zone.getTextStyles(resolution, 0)
        ]

    }

    else if (zone.isPoint()) {

        style = (f, resolution) => layer.getLayerStyleFunction(true)(feature, resolution)

    }

    else {

        const stroke = zone.showStroke || zone.isTransparent()
        const isField = zone.isFieldFeature()
        const points = (zone.isBuffer() || isField) ? false : true
        const color = isField ? [0xff, 0xff, 0xff, 0.4] : zone.fillColor
        let strokeColor = isField ? red : undefined
        const text = isField ? false : true

        if ((!strokeColor) && color) {
            strokeColor = darken(color, 0.3)
        }

        style = layer.getEditStyleFunction(feature, { points, color, stroke, strokeColor, text })

    }

    return style

}

export function getDrawingPolygonDefaultDrawingStyle(layer: Datalayer, color?: number[]) {

    const options = {
        points: true,
        stroke: true,
        color,
        text: false
    }

    return (feature, resolution) => layer.getEditStyleFunction(feature, options)(feature, resolution)

}

export function getDrawingLineStyle(feature: ol_Feature, zone: DrawingFeature, selected: boolean): ol_style.Style[] {

    const options = {
        width: (zone.lineWidth || 3) + (selected ? 2 : 0),
        color: zone.fillColor || [0, 0, 0, 0.5],
        showStroke: zone.showStroke || zone.isTransparent(),
        showPoints: selected,
        linePattern: zone.linePattern
    }

    return getLineStyle(feature, options)

}


export function getDrawingLineDefaultDrawingStyle(color?: number[]) {

    const options = {
        color: color || olblue,
        width: 3,
        showStroke: true,
        showPoints: true
    }

    return (feature, resolution) => getLineStyle(feature, options)

}

function getLineStyle(feature: ol_Feature, options: {
    color: number[],
    width: number,
    showStroke: boolean,
    linePattern?: LinePattern,
    showPoints: boolean
}) {

    const { color, width, showStroke, linePattern, showPoints } = options

    const stroke = showStroke
        ? new ol_style.Style({
            stroke: new ol_style.Stroke({
                color: '#fff',
                width: width + 2,
                lineDash: getLinePattern(linePattern)
            })
        })
        : null

    const styles = [
        stroke,
        new ol_style.Style({
            stroke: new ol_style.Stroke({
                color: color,
                width,
                lineDash: getLinePattern(linePattern)
            })
        }),
        showPoints && feature
            ? getFeaturePointStyle(feature)
            : null
    ]

    return styles.filter(s => !!s)

}

function getLinePattern(pattern: LinePattern) {

    switch (pattern) {

        case LinePattern.Dashes:
            return [5, 12]

        case LinePattern.Dots:
            return [0.5, 10]

        default:
            return undefined

    }
}
